import styled from 'styled-components';

import { IAddOn, IGlassesPackage } from '../../types';
import { PriceLine } from './PriceLine';
import { PriceDivider } from './PriceDivider';
import { breakpoints } from '../../constants';
import { applyDiscount, getPricingDetails, getQSVar } from '../../utils';

interface IProps {
    className?: string;
    selectedPackage: IGlassesPackage;
    selectedAddOns?: IAddOn[];
}

const BasePricingOverview = ({
    className,
    selectedPackage,
    selectedAddOns,
}: IProps) => {
    const pricingDetails = getPricingDetails(selectedPackage, selectedAddOns);

    if (!pricingDetails) return null;

    const { framePrice, glassesPrice, total } = pricingDetails;

    const { discountPercentage } = selectedPackage;
    const hasDiscount = !!discountPercentage && discountPercentage > 0;

    const frameName = `Montuur ${getQSVar('name') || ''}`;

    return (
        <div className={className}>
            <h3>Rekenvoorbeeld</h3>
            <PriceDivider />
            <PriceLine item={frameName} price={framePrice} />
            <PriceLine
                item={`${selectedPackage.name} ${
                    selectedPackage.name !== 'Basis' ? 'glaspakket' : ''
                }`}
                price={glassesPrice}
                priceFrom={hasDiscount ? selectedPackage.priceInt : undefined}
                subLabel={
                    hasDiscount
                        ? `${discountPercentage}% korting op glas *`
                        : undefined
                }
            />
            {selectedAddOns &&
                selectedAddOns.map((selectedAddOn) => {
                    const discountedPrice =
                        hasDiscount && selectedAddOn.priceInt > 0
                            ? applyDiscount(
                                  selectedAddOn.priceInt,
                                  discountPercentage
                              )
                            : selectedAddOn.priceInt;

                    return (
                        <PriceLine
                            included={selectedAddOn.priceInt === 0}
                            item={selectedAddOn.name}
                            key={selectedAddOn.id}
                            price={discountedPrice}
                            priceFrom={
                                hasDiscount && selectedAddOn.priceInt > 0
                                    ? selectedAddOn.priceInt
                                    : undefined
                            }
                        />
                    );
                })}
            <PriceDivider />
            <PriceLine bold isTotal item="Je betaalt" price={total} />
        </div>
    );
};

export const PricingOverview = styled(BasePricingOverview)`
    display: flex;
    flex-direction: column;
    padding: 30px;

    @media (${breakpoints.mediumMin}) {
        flex: 0 0 55%;
    }

    h3 {
        font-size: 20px;
        margin-bottom: 15px;
    }
`;
